import { validateForm, validateWPSProcesses, validateWPSFlux, validateWPSOscillation, validateWPSSignatures } from "../utility/common/TransactionComponents/TransactionValidationUtils";
import { WPSPage1, WPSPage1_Overlay, WPSPage3_Groove, WPSPage3_Overlay } from "./WPSObjects/WPSGroove_entity";
import { checkProcessAdded, checkduplicateProcess, checkFirstPageValidation, isDuplicate } from "./WPSObjects/WPS_Validations";
import { Action } from "../utility/common/constants/CommonConstants";

/**
 * Unified WPS validation function that replaces manual validation across all WPS pages
 * @param {Object} config - Validation configuration
 * @returns {Object} Validation result with errors and isError flag
 */
export const validateWPSForm = async ({
  headerObj,
  detailObj,
  WPStype,
  currentErrors = {},
  pageType = "page1", // page1, page2, page3
  action,
  setConsumError = null,
  setFluxError = null,
  setSupFilterError = null,
  todayDate = null,
  validateSignatures = false, // Only validate signatures when explicitly requested
}) => {
  let finalErrors = { ...currentErrors };
  let hasErrors = false;

  // Get required fields based on WPS type and page
  let requiredFields = {};
  switch (pageType) {
    case "page1":
      requiredFields = WPStype === "Groove" ? WPSPage1 : WPSPage1_Overlay;
      break;
    case "page2":
      // Add page2 configurations as needed
      requiredFields = {};
      break;
    case "page3":
      requiredFields = WPStype === "Groove" ? WPSPage3_Groove : WPSPage3_Overlay;
      break;
    default:
      break;
  }

  // Filter detail data for validation
  const detaildata = detailObj.filter((item) => item.WPSD_Process !== "");
  console.log('validateForm START - headerObj:', headerObj)
  // Use common validation for required fields
  const validationResult = validateForm({
    headerObj: headerObj,
    detailObj: detaildata,
    requiredFields,
    detailConfig: [],
    currentErrors: finalErrors,
    todayDate,
  });
  console.log('validateForm END - headerObj:', headerObj)
  hasErrors = validationResult.isError;
  finalErrors = validationResult.errors;

  // WPS-specific validations
  if (pageType === "page1") {
    const fluxValidation = validateWPSFlux(headerObj, detailObj);
    if (fluxValidation.isError) {
      hasErrors = true;
      finalErrors = { ...finalErrors, ...fluxValidation.error };
    }
  }

  if (pageType === "page3") {
    // Oscillation validation for Overlay type
    if (WPStype === "Overlay") {
      const oscillationValidation = validateWPSOscillation(headerObj);
      if (oscillationValidation.isError) {
        hasErrors = true;
        finalErrors = { ...finalErrors, ...oscillationValidation.error };
      }
    }

    // Signature validation only when explicitly requested (for Approve/Reject)
    if (validateSignatures) {
      const signatureValidation = validateWPSSignatures(headerObj, headerObj.WPSH_Approval_Status || headerObj.WPSH_Status);
      if (signatureValidation.isError) {
        hasErrors = true;
        finalErrors = { ...finalErrors, ...signatureValidation.error };
      }
    }


  }
  // WPS process validation
  const processValidation = validateWPSProcesses(detailObj, checkProcessAdded, checkduplicateProcess);
  if (processValidation.isError) {
    hasErrors = true;
  }

  console.log("Process", hasErrors, processValidation)
  // WPS first page radio validations
  if (pageType = "page1") {
    let firstpage = checkFirstPageValidation(headerObj, setConsumError, setFluxError, setSupFilterError)
    if (firstpage.isError)
      hasErrors = true
  }

  // Duplicate check for new records
  if ((action === Action.ActionCopy || action === Action.ActionAdd) && !hasErrors) {
    if (await isDuplicate(headerObj?.WPSH_Project_No, headerObj?.WPSH_WPS_No)) {
      hasErrors = true;
      finalErrors.WPSH_Project_No = {
        status: true,
        message: "Project Number & WPS Number already exists",
      };
    } else {
      finalErrors.WPSH_Project_No = {
        status: false,
        message: "",
      };
    }
  }
  console.log("Final Error", finalErrors, hasErrors)
  return {
    errors: finalErrors,
    isError: hasErrors,
  };
};

/**
 * WPS Done button validation - validates all pages like old system
 * @param {Object} config - Validation configuration
 * @returns {Object} Validation result
 */
export const validateWPSDoneForm = async ({
  headerObj,
  detailObj,
  WPStype,
  currentErrors = {},
  action,
  todayDate = null,
}) => {
  let finalErrors = { ...currentErrors };
  let hasErrors = false;

  // Get required fields for Page 1 and Page 3 (like old system)
  const page1Fields = WPStype === "Groove" ? WPSPage1 : WPSPage1_Overlay;
  const page3Fields = WPSPage3_Groove; // Use Page 3 fields
  const page2Fields = {}; // Page 2 fields if needed

  const allRequiredFields = { ...page1Fields, ...page2Fields, ...page3Fields };

  // Filter detail data for validation
  const detaildata = detailObj.filter((item) => item.WPSD_Process !== "");

  // Use common validation for required fields (NO signature validation)
  const validationResult = validateForm({
    headerObj,
    detailObj: detaildata,
    requiredFields: allRequiredFields,
    detailConfig: [],
    currentErrors: finalErrors,
    todayDate,
  });

  hasErrors = validationResult.isError;
  finalErrors = validationResult.errors;

  // WPS-specific validations (same as old system)
  const fluxValidation = validateWPSFlux(headerObj, detailObj);
  if (fluxValidation.isError) {
    hasErrors = true;
    finalErrors = { ...finalErrors, ...fluxValidation.error };
  }

  // Oscillation validation for Overlay type
  if (WPStype === "Overlay") {
    const oscillationValidation = validateWPSOscillation(headerObj);
    if (oscillationValidation.isError) {
      hasErrors = true;
      finalErrors = { ...finalErrors, ...oscillationValidation.error };
    }
  }

  // WPS process validation
  const processValidation = validateWPSProcesses(detailObj, checkProcessAdded, checkduplicateProcess);
  if (processValidation.isError) {
    hasErrors = true;
  }

  // Duplicate check for new records
  if ((action === Action.ActionCopy || action === Action.ActionAdd) && !hasErrors) {
    if (await isDuplicate(headerObj?.WPSH_Project_No, headerObj?.WPSH_WPS_No)) {
      hasErrors = true;
      finalErrors.WPSH_Project_No = {
        status: true,
        message: "Project Number & WPS Number already exists",
      };
    } else {
      finalErrors.WPSH_Project_No = {
        status: false,
        message: "",
      };
    }
  }

  return {
    errors: finalErrors,
    isError: hasErrors,
  };
};

/**
 * Unified WPS temp validation function
 * @param {Object} config - Validation configuration
 * @returns {Object} Validation result
 */
export const validateWPSTempForm = async ({
  headerObj,
  detailObj,
  currentErrors = {},
  action,
  todayDate,
}) => {
  let tempErrors = { ...currentErrors };
  let isError = false;

  // Validate required temp fields
  const requiredTempFields = {
    WPSH_Project_No: headerObj.WPSH_Project_No?.trim(),
    WPSH_WPS_No: headerObj.WPSH_WPS_No?.trim(),
  };

  Object.entries(requiredTempFields).forEach(([key, value]) => {
    if (!value || value === "") {
      isError = true;
      tempErrors[key] = {
        status: true,
        message: "This field is required",
      };
    }
  });

  // Date validation
  if (headerObj.WPSH_WPS_Date > todayDate) {
    isError = true;
    tempErrors.WPSH_WPS_Date = {
      status: true,
      message: "Future Date Not Allowed.",
    };
  }

  // Duplicate check
  if ((action === Action.ActionCopy || action === Action.ActionAdd) && !isError) {
    if (await isDuplicate(headerObj.WPSH_Project_No, headerObj.WPSH_WPS_No)) {
      isError = true;
      tempErrors.WPSH_Project_No = {
        status: true,
        message: "Project Number & WPS Number already exists",
      };
    } else {
      tempErrors.WPSH_Project_No = {
        status: false,
        message: "",
      };
    }
  }

  // Process validation
  const processValidation = validateWPSProcesses(detailObj, checkProcessAdded, checkduplicateProcess);
  if (processValidation.isError) {
    isError = true;
  }

  // Flux validation for overlay
  const fluxValidation = validateWPSFlux(headerObj, detailObj);
  if (fluxValidation.isError) {
    isError = true;
    tempErrors = { ...tempErrors, ...fluxValidation.error };
  }

  return {
    errors: tempErrors,
    isError,
  };
};

/**
 * WPS radio button validation - validates all pages including signatures when approving/rejecting
 * @param {Object} config - Validation configuration
 * @returns {Object} Validation result
 */
export const validateWPSRadioForm = async ({
  headerObj,
  detailObj,
  WPStype,
  currentErrors = {},
  action,
  todayDate = null,
}) => {
  // Use the Done form validation first
  const doneValidation = await validateWPSDoneForm({
    headerObj,
    detailObj,
    WPStype,
    currentErrors,
    action,
    todayDate,
  });

  let finalErrors = doneValidation.errors;
  let hasErrors = doneValidation.isError;

  // Add signature validation for radio button actions
  const signatureValidation = validateWPSSignatures(headerObj, headerObj.WPSH_Approval_Status || headerObj.WPSH_Status);
  if (signatureValidation.isError) {
    hasErrors = true;
    finalErrors = { ...finalErrors, ...signatureValidation.error };
  }

  return {
    errors: finalErrors,
    isError: hasErrors,
  };
};

